import { Link } from 'react-router-dom';

const stats = [
  { value: '2,600+', label: '收录作品' },
  { value: '98%', label: '更新及时率' },
  { value: '40万', label: '月活跃影迷' },
  { value: '12', label: '内容标签' },
];

const highlights = [
  {
    icon: 'ri-search-eye-line',
    title: '按需筛选，不被算法牵着走',
    desc: '地区、年份、评分多维组合筛选，配合最新、最热、评分三种排序，想看的类型一眼定位。',
  },
  {
    icon: 'ri-bookmark-3-line',
    title: '一张属于你的片单',
    desc: '收藏的作品保存在本机浏览器中，刷新与再次访问都不会丢，随时回到没看完的清单。',
  },
  {
    icon: 'ri-device-line',
    title: '桌面与手机同样顺手',
    desc: '移动端采用折叠菜单与弹出筛选层，卡片自适应为单列或双列，通勤路上也能轻松浏览。',
  },
];

export default function PlatformIntro() {
  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          <div className="p-6 md:p-10">
            <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-50 text-primary-700 text-xs font-medium">
              <i className="ri-leaf-line"></i> 关于丝瓜视频
            </span>
            <h2 className="mt-4 font-heading text-2xl md:text-3xl font-black text-foreground-950 leading-snug">
              把找片这件事，<br className="hidden md:block" />
              变得简单一点
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed">
              丝瓜视频聚合电影、电视剧与综艺三类内容，为影视爱好者提供一个清爽的浏览与查找入口。我们不堆砌信息，而是把作品的核心信息——类型、主创、年份、剧情与口碑——整理成清晰的结构，让每一次浏览都更有方向感。
            </p>
            <div className="mt-6 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {stats.map((stat) => (
                <div key={stat.label} className="rounded-md bg-background-50 border border-background-200 px-3 py-3">
                  <div className="font-heading text-lg md:text-xl font-black text-primary-600">
                    {stat.value}
                  </div>
                  <div className="mt-0.5 text-[11px] text-foreground-500">{stat.label}</div>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 px-5 h-10 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              了解更多平台信息
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="p-6 md:p-10 lg:border-l border-t lg:border-t-0 border-background-200 bg-background-50">
            <h3 className="font-heading text-base font-bold text-foreground-950 mb-4">
              平台能力一览
            </h3>
            <div className="space-y-3">
              {highlights.map((item, i) => (
                <div key={item.title} className="flex gap-3">
                  <span
                    className={`w-9 h-9 shrink-0 rounded-md flex items-center justify-center ${
                      i === 1
                        ? 'bg-accent-50 text-accent-700'
                        : 'bg-secondary-100 text-secondary-700'
                    }`}
                  >
                    <i className={`${item.icon} text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="font-heading text-sm font-bold text-foreground-950">
                      <Link to="/about" className="hover:text-primary-600 transition-colors">
                        {item.title}
                      </Link>
                    </h4>
                    <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-5 rounded-md border border-dashed border-background-300 px-4 py-3">
              <p className="text-[11px] text-foreground-500 leading-relaxed">
                温馨提示：本页面为影视门户演示站点，作品与人员信息均为虚构内容，未接入真实播放服务。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}